export default {
  lgpd: {
    text1:
      'Usamos cookies para recoger informaciones así entendemos de qué forma Ud. interactúa con nuestro sitio Web, eso nos permite mejorar y personalizar su experiencia de navegación y realizar análisis y métricas sobre nuestros visitantes. Para obtener más informaciones, lea nuestra',
    link: 'Política de Privacidad.',
    text2: 'Al hacer clic en Acepto, Ud. concuerda con la utilización de estos cookies.',
    buttonContent: 'Acepto',
  },
}
